import { JargonTranslation } from './jargonTypes'

export const enGB: JargonTranslation = {
  abnEntity: 'a Company Registration Number',
  abn: 'CRN',
  abnLowercase: 'CRN',
  abnSearchName: 'Companies House',
  abns: 'CRNs',
  abnsLowercase: 'CRNs',
  companyInduction: 'Company Induction',
  companyInductions: 'Company Inductions',
  defect: 'Snag',
  defects: 'Snags',
  drawing: 'Drawing',
  drawings: 'Drawings',
  favourite: 'Favourite',
  favourites: 'Favourites',
  induct: 'Induct',
  inducts: 'Inducts',
  inducted: 'Inducted',
  inducting: 'Inducting',
  induction: 'Induction',
  inductions: 'Inductions',
  itp: 'ITP',
  itps: 'ITPs',
  people: 'People',
  peoples: 'People',
  preStart: 'Toolbox Talk',
  preStarts: 'Toolbox Talks',
  project: 'Project',
  projects: 'Projects',
  projectHoursBudget: 'Project Hours Budget',
  projectHoursBudgets: 'Project Hours Budgets',
  placeholderAddress: '78 High Street, London SW1A 1AA',
  placeholderProjectName: '78 High Street',
  placeholderPhoneNumber: '020 7123 4567',
  register: 'Register',
  registers: 'Registers',
  sdsLibrary: 'COSHH Sheets',
  sdsLibraries: 'COSHH Sheets',
  signOn: 'Sign On',
  signOns: 'Sign Ons',
  siteInduction: 'Site Induction',
  siteInductions: 'Site Inductions',
  siteDiary: 'Site Diary',
  siteDiaries: 'Site Diaries',
  staff: 'Staff',
  staffs: 'Staffs',
  subcontractor: 'Company',
  subcontractors: 'Companies',
  swms: 'RAMS',
  swmss: 'RAMS',
  swmsFullTitle: 'Risk Assessment Method Statement',
  ticket: 'Certification',
  tickets: 'Certifications',
  timesheet: 'Timesheet',
  timesheets: 'Timesheets',
  worker: 'Operative',
  workers: 'Operatives',
}
